import { render, staticRenderFns } from "./Recollects.vue?vue&type=template&id=33a26956"
import script from "./Recollects.vue?vue&type=script&lang=js"
export * from "./Recollects.vue?vue&type=script&lang=js"
import style0 from "./Recollects.vue?vue&type=style&index=0&id=33a26956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports